<div class="image-editor">
  <!-- Dropdown menu -->
  <div class="editor-content scroll-style" *ngIf="!isViewAll"
    style="overflow: auto; overflow-x: hidden;">
    <!-- Dropdown menu -->
    <ul nz-menu nzMode="inline">
      <!-- Cấu hình cơ bản -->
      <li nz-submenu [nzTitle]="'thong_so_co_ban' | translate" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <div class="editor-field-body">
            <!-- Độ mờ đục -->
            <div class="mb-3">
              <div class="config-name mt-0">
                <p>{{'do_trong_suot' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="1" [nzStep]="0.01"
                  [(ngModel)]="class['image-img']['opacity']"
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="1" [nzStep]="0.01" 
                [ngModel]="class['image-img']['opacity'] | vhnumber"
                (ngModelChange)="class['image-img']['opacity'] = $event" 
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
            <!-- Độ co giãn -->
            <div class="my-3">
              <div class="config-name">
                <p>{{'do_co_gian' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="1" [nzStep]="0.01"
                  [(ngModel)]="config['transform_image'].transform_scale"
                  (nzBlur)="updateScale()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="1" [nzStep]="0.01"
                [(ngModel)]="config['transform_image'].transform_scale"
                (nzOnAfterChange)="updateScale()">
              </nz-slider>
            </div>
            <!-- Khoảng cách giữa ảnh chính và list ảnh nhỏ -->
            <div class="my-3">
              <div class="config-name">
                <p>{{'khoang_cach_voi_nhom_anh_nho' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100"
                  [ngModel]="class['image-detail']['gap'] | vhnumber"
                  (ngModelChange)="class['image-detail']['gap'] = $event +'px'" 
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="100" 
                [ngModel]="class['image-detail']['gap'] | vhnumber"
                (ngModelChange)="class['image-detail']['gap'] = $event +'px'" 
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>

          </div>
        </div>
      </li>
      <!-- set kiểu viền và màu viền -->
      <li nz-submenu [nzTitle]="'duong_vien_anh_chinh' | translate" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-borders-config 
          [id_object]="objectChoosing._id"
          [device]="device" 
          [class]="class"  [elementChoosing]="objectChoosing"
          [borderClass]="class['image-img']">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="config-name view-more-btn">
          <p (click)="openViewDetail.emit()">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- Cấu hình filter -->
      <li nz-submenu [nzTitle]="'bo_loc_hinh_anh' | translate" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <app-brightness-contrast-config 
          [id_object]="objectChoosing._id"
          [device]="device"  
          [staticdata]="staticdata"
          [class]="class" 
          [config]="config"
          [filterConfig]="config['filter']" 
          [opacityClass]="class['image-img']">
        </app-brightness-contrast-config>
      </li>
      <!-- Cấu hình object-fit -->
      <li nz-submenu [nzTitle]="'do_bao_phu' | translate" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <div class="editor-field">
          <app-object-fit-config  
            [objectChoosing]="objectChoosing"
            [device]="device" 
            [class]="class" 
            [objectFitClass]="class['image-img']"
            (isViewAll)="isOpenViewAll($event)">
          </app-object-fit-config>
        </div>
      </li>
      <!-- Vị trí hình ảnh -->
      <li nz-submenu [nzTitle]="'vi_tri_hinh_anh' | translate" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="editor-field">  
          <!-- Ngang -->
          <div>
            <div class="config-name mt-0">
              <p>{{'ngang' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1" 
                [(ngModel)]="config['object_fit_image']['object_x']" 
                (nzBlur)="handleSetPositionImage()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"  
              [(ngModel)]="config['object_fit_image']['object_x']"
              (ngModelChange)="config['object_fit_image']['object_x'] = $event"
              (nzOnAfterChange)="handleSetPositionImage()">
            </nz-slider>
          </div>
          <!-- Dọc -->
          <div class="my-3">
            <div class="config-name">
              <p>{{'doc' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1" 
                [(ngModel)]="config['object_fit_image']['object_y']"
                (nzBlur)="handleSetPositionImage()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
              [(ngModel)]="config['object_fit_image']['object_y']"
              (ngModelChange)="config['object_fit_image']['object_y'] = $event"
              (nzOnAfterChange)="handleSetPositionImage()">
            </nz-slider>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>